import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { token } from 'odyssey';

export const EntityItem = styled.div`
  margin: 0 6px;
  min-width: 80vw;
  max-width: 80vw;
  & > a {
    width: 100%;
  }

  ${media.md`
    margin: 0 10px;
    min-width: 400px;
    max-width: 400px;
  `}
`;

export const Details = styled.div`
  height: 96px;
  padding: 10px 0;
`;

export const Title = styled.div`
  font-size: ${token('font-size-sm')};
  font-weight: ${token('font-weight-md')};
  color: ${token('color-text-dark')};
`;
